var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoMagnifier(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.HOME-Copy-2",
    transform: "translate(-356.000000, -3244.000000)",
    fill: "#767474",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23",
    transform: "translate(-1.000000, 3019.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15-Copy",
    transform: "translate(235.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4-copy",
    transform: "translate(0.000000, 42.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(0.000000, 68.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "np_magnify_1319147_000000",
    transform: "translate(130.000000, 122.884615) scale(-1, 1) translate(-130.000000, -122.884615) translate(122.000000, 114.384615)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.334608,10.5800906 C11.2264982,10.7219823 11.2417028,10.9398924 11.3700814,11.0682704 L15.8112306,15.5076837 C16.0629231,15.7610667 16.0629231,16.1732498 15.8112306,16.4266155 C15.5578473,16.6783077 15.1456637,16.6783077 14.8922976,16.4266155 L10.4528782,11.9854724 C10.3261865,11.8587809 10.1065896,11.8435807 9.96301119,11.9499991 C9.96301119,11.9499991 9.91064714,11.9956083 9.74510082,12.1054045 C8.75014502,12.769284 7.55587805,13.1561002 6.27036644,13.1561002 C2.8074809,13.1561002 0,10.3486232 0,6.88574242 C0,3.42286164 2.8074809,0.615384615 6.27036644,0.615384615 C9.73325199,0.615384615 12.5407329,3.42286164 12.5407329,6.88574242 C12.5407329,8.17631178 12.1505258,9.37563663 11.4832896,10.3722776 C11.3751799,10.5327512 11.3346387,10.5800513 11.3346387,10.5800513 L11.334608,10.5800906 Z M6.27031412,11.8588112 C9.01699408,11.8588112 11.2433634,9.63244498 11.2433634,6.8857688 C11.2433634,4.13909262 9.01699408,1.9127264 6.27031412,1.9127264 C3.52363415,1.9127264 1.29726487,4.13909262 1.29726487,6.8857688 C1.29726487,9.63244498 3.52363415,11.8588112 6.27031412,11.8588112 Z",
    id: "Shape"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMagnifier);
export default __webpack_public_path__ + "static/media/ico_magnifier.218ee31f741c04c11ce4f5c84e9c9c67.svg";
export { ForwardRef as ReactComponent };